import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-mid-voyage-reports',
  templateUrl: './mid-voyage-reports.component.html',
  styleUrls: ['./mid-voyage-reports.component.scss']
})
export class MidVoyageReportsComponent {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('table', { static: false }) table!: ElementRef;
  elements: any;
  paginatedData: any[] = [];
  itemsPerPage: number = 15;
  currentPage: number = 0;
  rowData: any;
  counter = 1;
  conditionOptions = ['Laden', 'Ballast'];
  filteredData: any;
  visible:boolean=false
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      condition: ['', [Validators.required]],
    });
  }
  ngOnInit() {
    this.paginateData();
    this.sharedDataService.rowData$.subscribe((rowData) => {
      this.rowData = rowData;
      if (this.rowData) {
        localStorage.setItem('shipName', this.rowData.shipName);
        localStorage.setItem('segment', this.rowData.segment);
      }

    });
    // this.loadData();
  }
  toggleMapView() {
    this.visible = !this.visible;
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  loadData() {
    // const storedShipName = localStorage.getItem('shipName');
    // const storedSegment = localStorage.getItem('segment');
    // this.sharedDataService
    //   .getVesselView(storedShipName, storedSegment,true)
    //   .subscribe((data) => {
    //     this.elements = data.map((item: any, index: number) => ({
    //       sNo: index + 1,
    //       shipName: item.shipName,
    //       segment: item.segment.toUpperCase(),
    //       voyNumber: item.voyNumber,
    //       condition: item.condition.toUpperCase(),
    //       from: item.from.toUpperCase(),
    //       fromDate: item.fromDate,
    //       to: item.to.toUpperCase(),
    //       toDate: item.toDate,
    //       instructedSpd: item.instructedSpd,
    //       cpConsumption: item.cpConsumption,
    //       goodWxPerSpd: item.goodWxPerSpd.toFixed(2),
    //       voyAvgSpd: item.voyAvgSpd.toFixed(2),
    //       goodWxDailyConsp: {
    //         HSFO:
    //           item.goodWxDailyConsp.hsfo !== 0
    //             ? item.goodWxDailyConsp.hsfo.toFixed(2)
    //             : '__',
    //         VLSFO:
    //           item.goodWxDailyConsp.vlsfo !== 0
    //             ? item.goodWxDailyConsp.vlsfo.toFixed(2)
    //             : '__',
    //         GO:
    //           item.goodWxDailyConsp.go !== 0
    //             ? item.goodWxDailyConsp.go.toFixed(2)
    //             : '__',
    //       },
    //       goodWxPer: (item.goodWxPer * 100).toFixed(1),
    //       goodWxDist: item.goodWxDist,
    //       voyDuration: item.voyDuration,
    //       voyDistance: item.voyDistance,
    //       totalBunkerConsumption: item.totalBunkerConsumption,
    //       averageDialyCon: item.averageDialyCon.toFixed(2),
    //       timeLost: item.timeLostGain.toFixed(1),
    //       bunkerLostOrGain: {
    //         HSFO:
    //           item.bunkerLostOrGain.hsfo !== 0
    //             ? item.bunkerLostOrGain.hsfo.toFixed(2)
    //             : '__',
    //         VLSFO:
    //           item.bunkerLostOrGain.vlsfo !== 0
    //             ? item.bunkerLostOrGain.vlsfo.toFixed(2)
    //             : '__',
    //         GO:
    //           item.bunkerLostOrGain.go !== 0
    //             ? item.bunkerLostOrGain.go.toFixed(2)
    //             : '__',
    //       },
    //       claimEst: {
    //         hire: item.claimEst.hire,
    //         bunkPrice: item.claimEst.bunkPrice,
    //       },
    //     }));
    //     this.paginateData();
    //   });

    // this.elements = [
    //   {
    //     sNo: this.counter++,
    //     shipName: 'LA PRIDE',
    //     segment: 'Aframax',
    //     voyNumber: 'af20ea66-2e0d-ff68-df27-0afe03fb055b',
    //     condition: 'laden',
    //     from: 'MURMANSK',
    //     to: 'CHINA',
    //     fromDate: '2023-05-31 09:00',
    //     toDate: '2023-06-16 19:00',
    //     instructedSpd: 13.5,
    //     cpConsumption: 42.5,
    //     goodWxPerSpd: 13.228724,
    //     voyAvgSpd: 12.678851,
    //     bunkerLostOrGain: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: -0.69326925,
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     goodWxPer: 0.5121499176276771,
    //     goodWxDist: 2487,
    //     voyDuration: 383,
    //     voyDistance: 4856,
    //     totalBunkerConsumption: 34.5,
    //     averageDialyCon: 2.1618798,
    //     timeLost: 0,
    //     goodWxDailyConsp: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: 4.404255319148936,
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     claimEst: {
    //       hire: '',
    //       bunkPrice: '',
    //     },
    //   },
    //   {
    //     sNo: this.counter++,
    //     shipName: 'LA PRIDE',
    //     segment: 'Aframax',
    //     voyNumber: '66434f69-6201-d199-cabf-92ea92a757ef',
    //     condition: 'laden',
    //     from: 'NOVOROSSIK',
    //     to: 'BURGAS',
    //     fromDate: '2023-01-28 04:06',
    //     toDate: '2023-01-29 19:00',
    //     instructedSpd: 13.5,
    //     cpConsumption: 46,
    //     goodWxPerSpd: 0,
    //     voyAvgSpd: 12.210797,
    //     bunkerLostOrGain: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: 0 !== 0 ? 0 : '__',
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     goodWxPer: 0,
    //     goodWxDist: 0,
    //     voyDuration: 38.9,
    //     voyDistance: 475,
    //     totalBunkerConsumption: 56.3,
    //     averageDialyCon: 34.735218,
    //     timeLost: 0,
    //     goodWxDailyConsp: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: 0 !== 0 ? 0 : '__',
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     claimEst: {
    //       hire: '',
    //       bunkPrice: '',
    //     },
    //   },
    //   {
    //     sNo: this.counter++,
    //     shipName: 'LA PRIDE',
    //     segment: 'Aframax',
    //     voyNumber: '66434f69-6201-d199-cabf-92ea92a757ef',
    //     condition: 'laden',
    //     from: 'NOVOROSSIK',
    //     to: 'BURGAS',
    //     fromDate: '2023-01-28 04:06',
    //     toDate: '2023-01-29 19:00',
    //     instructedSpd: 13.5,
    //     cpConsumption: 46,
    //     goodWxPerSpd: 0,
    //     voyAvgSpd: 12.210797,
    //     bunkerLostOrGain: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: 0 !== 0 ? 0 : '__',
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     goodWxPer: 0,
    //     goodWxDist: 0,
    //     voyDuration: 38.9,
    //     voyDistance: 475,
    //     totalBunkerConsumption: 56.3,
    //     averageDialyCon: 34.735218,
    //     timeLost: 0,
    //     goodWxDailyConsp: {
    //       HSFO: 0 !== 0 ? 0 : '__',
    //       VLSFO: 0 !== 0 ? 0 : '__',
    //       GO: 0 !== 0 ? 0 : '__',
    //     },
    //     claimEst: {
    //       hire: '',
    //       bunkPrice: '',
    //     },
    //   },
    // ];
    // this.paginateData();
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'sNo':
        case 'shipName':
        case 'segment':
        case 'voyNumber':
        case 'condition':
          return this.compare(a[sort.active], b[sort.active], isAsc);
        default:
          return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  showDetails(row: any) {
    this.router.navigate(['/vp-shipView']);
  }

  downloadIcon(ow: any) {
    this.toastr.success(ToasterMessages.UnderDev);
  }
  backClick() {
    this.router.navigate(['/']);
  }
  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;

  // Function to enter edit mode
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }

  // Function to exit edit mode
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
        bunkPrice * (VLSFO || 0) +
        bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }

  clearClick() {
    this.filterForm.reset();
    this.loadData();
  }

  filterClick() {
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const condition = this.filterForm.get('condition')?.value;
    if ((from_date_str && !to_date_str) || (!from_date_str && to_date_str)) {
      console.warn('Please select both from and to dates.');
      return;
    }
    const formatDateToYYYYMMDD = (dateString: string | null) => {
      if (dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return null;
    };

    const from_date = formatDateToYYYYMMDD(from_date_str);
    const to_date = formatDateToYYYYMMDD(to_date_str);

    const filteredData = this.elements.filter((element: any) => {
      const elementFromDate = element.fromDate
        ? formatDateToYYYYMMDD(element.fromDate)
        : null;

      return (
        (!from_date || (elementFromDate && elementFromDate >= from_date)) &&
        (!to_date || (elementFromDate && elementFromDate <= to_date)) &&
        (!condition ||
          element.condition?.toLowerCase() === condition.toLowerCase())
      );
    });

    this.filteredData = filteredData
    this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    this.currentPage = 0;
  }
  exportClick() {
    const data = this.filteredData || this.elements
    const csvHeader =
      'Ship Name,Segment,Voy Number,condition,From,To,COSP,EOSP,Instructed Speed,Cp Consumption,Good Wx Performance Speed,Voy Avg Speed,Good Wx HSFO,Good Wx VLSFO,Good Wx GO,Good Wx %,Good Wx Distance,Voy Duration,Voy Distance,Total Bunker consumption,Avg Daily Consumption,Time Lost (or) Gain,HSFO,VLSFO,GO,Daily Hire,Avg Bunker Price,Claimable Amount';
    const csvData = data
      .map((item: any) => {
        const bunkLostGain = item.bunkerLostOrGain
          ? `${item.bunkerLostOrGain.HSFO},${item.bunkerLostOrGain.VLSFO},${item.bunkerLostOrGain.GO}`
          : ',,';
        const goodWxDailyConsp = item.goodWxDailyConsp
          ? `${item.goodWxDailyConsp.HSFO},${item.goodWxDailyConsp.VLSFO},${item.goodWxDailyConsp.GO}`
          : ',,';
        const claimEst = item.claimEst
          ? `${item.claimEst.hire},${item.claimEst.bunkPrice}`
          : ',';
        const goodWxPer = (item.goodWxPer * 100).toFixed(1);
        return `${item.shipName},${item.segment},${item.voyNumber},${
          item.condition
        },${item.from},${item.to},${item.fromDate},${item.toDate},${
          item.instructedSpd
        },${item.cpConsumption},${item.goodWxPerSpd},${
          item.voyAvgSpd
        },${goodWxDailyConsp},${goodWxPer},${item.goodWxDist},${
          item.voyDuration
        },${item.voyDistance},${item.totalBunkerConsumption},${
          item.averageDialyCon
        },${
          item.timeLost
        },${bunkLostGain},${claimEst},${this.calculateClaimableAmount(
          item.claimEst
        )}`;
      })
      .join('\n');

    // Create the CSV content
    const csvContent = `${csvHeader}\n${csvData}`;

    // Create a Blob and download link for the CSV file
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'table_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  printTable() {
    window.print();
  }
  downloadClick() {
    const from_date = this.filterForm.get('from_date')?.value;
    const to_date = this.filterForm.get('to_date')?.value;
    const condition = this.filterForm.get('condition')?.value;
    const storedShipName = localStorage.getItem('shipName');
    const storedSegment = localStorage.getItem('segment');

    this.toastr.success(ToasterMessages.UnderDev);
  }
}
